import api from "./axios";


// ============================================================
// COLLECTIONS
// ============================================================

export const getCollections = async (
    page = 1,
    limit = 10,
    filters = {}
) => {

    const response = await api.get(
        "/collections",
        {
            params: {
                page,
                limit,
                ...filters,
            },
        }
    );

    return response.data;
};


export const getCollection = async (
    id
) => {

    const response = await api.get(
        `/collections/${id}`
    );

    return response.data;
};


export const createCollection = async (
    data
) => {

    const response = await api.post(
        "/collections",
        data
    );

    return response.data;
};


export const updateCollection = async (
    id,
    data
) => {

    const response = await api.patch(
        `/collections/${id}`,
        data
    );

    return response.data;
};


export const submitCollection = async (
    id
) => {

    const response = await api.post(
        `/collections/${id}/submit`
    );

    return response.data;
};


export const verifyCollection = async (
    id,
    data = {}
) => {

    const response = await api.post(
        `/collections/${id}/verify`,
        data
    );

    return response.data;
};


export const rejectCollection = async (
    id,
    reason
) => {

    const response = await api.post(
        `/collections/${id}/reject`,
        {
            reason,
        }
    );

    return response.data;
};


export const cancelCollection = async (
    id
) => {

    const response = await api.delete(
        `/collections/${id}`
    );

    return response.data;
};


// ============================================================
// OPENING BALANCE
// ============================================================

export const getOpeningBalances = async () => {

    const response = await api.get(
        "/collections/balances/opening"
    );

    return response.data;
};


export const createOpeningBalance = async (
    data
) => {

    const response = await api.post(
        "/collections/balances/opening",
        data
    );

    return response.data;
};


// ============================================================
// OUTSTANDING BALANCE
// ============================================================

export const getOutstandingBalances = async () => {

    const response = await api.get(
        "/collections/balances/outstanding"
    );

    return response.data;
};


export const createOutstandingBalance = async (
    data
) => {

    const response = await api.post(
        "/collections/balances/outstanding",
        data
    );

    return response.data;
};


// ============================================================
// RECEIPT UPLOAD
// ============================================================

export const uploadCollectionReceipt = async (
    file
) => {

    const formData = new FormData();

    formData.append(
        "file",
        file
    );

    formData.append(
        "folder",
        "collections"
    );

    const response = await api.post(
        "/uploads",
        formData,
        {
            headers: {
                "Content-Type": undefined,
            },
        }
    );

    return response.data;
};